import React, { useEffect, useRef } from "react";
import PrimaryButton from "../designSystem/buttons/PrimaryButton";

const GOOGLE_REVIEW_URL =
  "https://www.google.com/search?hl=en-GB&gl=uk&q=AK+Mortgages,+28+Stanshaw+Cl,+Bristol+BS16+1JY&ludocid=342448040031340218&lsig=AB86z5VEKhcAoqAybGWHohigG80a#lrd=0x487191209ba8116f:0x4c09ead9418c6ba,3";

const ContactUsComponent = () => {
  const embedRef = useRef(null);

  useEffect(() => {
    const container = embedRef.current;

    if (!container) {
      return undefined;
    }

    const existingScript = container.querySelector("script[data-pd-loader]");

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://webforms.pipedrive.com/f/loader";
      script.async = true;
      script.setAttribute("data-pd-loader", "true");
      container.appendChild(script);
    }

    return () => {
      const script = container.querySelector("script[data-pd-loader]");
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <section
      id="contact-us"
      className="background-container bg-white contact-section"
    >
      <div className="content-container column-center contact-section-inner">
        {/* <div className="column gap-s">
        <div className="content-semibold primary uppercase align-left">
          contact
        </div>
      </div> */}
        <div className="contact-form-column">
          <div
            ref={embedRef}
            className="pipedriveWebForms contact-form-embed"
            data-pd-webforms="https://webforms.pipedrive.com/f/6OCEff3utC8eGAE8aIEqrI7OQhrw32dWpstBUIskWAnOfg1rCWIyelMzdwFpmauVR9"
          />
        </div>
        <aside className="contact-details-column" aria-label="Contact details">
          <div className="contact-location-copy align-left">
            <h2 className="h4 primary">Contact Details</h2>
            <div className="contact-details">
              <div className="contact-detail">
                <span className="body2-semibold text-primary-2 uppercase">
                  Email
                </span>
                <a
                  className="body1 primary contact-link"
                  href="mailto:hello@akmortgages.uk"
                >
                  hello@akmortgages.uk
                </a>
              </div>
              <div className="contact-detail">
                <span className="body2-semibold text-primary-2 uppercase">
                  Telephone
                </span>
                <a
                  className="body1 primary contact-link"
                  href="tel:+441172351750"
                >
                  0117 2351750
                </a>
              </div>
              <div className="contact-detail">
                <span className="body2-semibold text-primary-2 uppercase">
                  Address
                </span>
                <a
                  className="body1 primary contact-link"
                  href="https://www.google.com/maps/search/?api=1&query=28%20Stanshaw%20Close%2C%20Bristol%20BS16%201JY"
                  target="_blank"
                  rel="noreferrer"
                >
                  28 Stanshaw Close, Bristol BS16 1JY
                </a>
              </div>
            </div>
          </div>
          {/* <a
            className="primary-button contact-review-button"
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="button-text">Leave a Review</span>
          </a> */}
          <PrimaryButton
            text="Leave a Review"
            onClick={() => window.open(GOOGLE_REVIEW_URL, "_blank")}
          />
          <iframe
            className="contact-map"
            title="Map showing 28 Stanshaw Close, Bristol BS16 1JY"
            src="https://www.google.com/maps?q=28%20Stanshaw%20Close%2C%20Bristol%20BS16%201JY&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </aside>
      </div>
    </section>
  );
};

export default ContactUsComponent;
